export const getters = {
  toggleProfile(state) {
    return state.toggleProfile;
  }
};
